const ACpricingConfigDelhi = {
  Split: {
    10: {
      "3+3year": {
        subscription: 1564,
        depositamount: 6000,
        priceAfter3Years: 1092,
        installetionCharge: 1770,
        addOn: 25,
      },
      "3+2year": {
        subscription: 1328,
        depositamount: 6000,
        priceAfter3Years: 856,
        installetionCharge: 1770,
        addOn: 25,
      },
    },
    15: {
      "3+3year": {
        subscription: 1564,
        depositamount: 7000,
        priceAfter3Years: 1092,
        installetionCharge: 1770,
        addOn: 25,
      },
      "3+2year": {
        subscription: 1328,
        depositamount: 7000,
        priceAfter3Years: 856,
        installetionCharge: 1770,
        addOn: 25,
      },
    },
    20: {
      "3+3year": {
        subscription: 1918,
        depositamount: 8000,
        priceAfter3Years: 1210,
        installetionCharge: 1770,
        addOn: 25,
      },
      "3+2year": {
        subscription: 1623,
        depositamount: 8000,
        priceAfter3Years: 1033,
        installetionCharge: 1770,
        addOn: 25,
      },
    },
  },
  Cassette: {
    20: {
      "3+3year": {
        subscription: 2655,
        depositamount: 15000,
        priceAfter3Years: 1475,
        installetionCharge: 3894,
      },
      "3+2year": {
        subscription: 2213,
        depositamount: 15000,
        priceAfter3Years: 1269,
        installetionCharge: 3894,
        addOn: 50,
      },
    },
    30: {
      "3+3year": {
        subscription: 3481,
        depositamount: 18000,
        priceAfter3Years: 1593,
        installetionCharge: 3894,
      },
      "3+2year": {
        subscription: 2921,
        depositamount: 18000,
        priceAfter3Years: 1387,
        installetionCharge: 3894,
        addOn: 50,
      },
    },
  },
};

export default ACpricingConfigDelhi;
